<template>
	<div class="con">
		<section  style="width: 100%;">
			<div  class="form" ref="print">
				<p class="title">干部任免审批表</p>
				<div class="form-wrapper">
					<div class="form-wrapper-up" >
						<!--第一行-->
						<div style="width: 500px;">
							<div class="bl clearfix b br" style="width: 400px;">
								<div class="b bb line">
									<span style="flex:0 0 55px;">姓名</span>
									<span class="bm" style="flex:0 0 70px;">{{name}}</span>
									<span class="br" style="flex:0 0 60px;">性别</span>
									<span class="br" style="flex:0 0 80px;">{{sex}}</span>
									<span class="br" style="flex:0 0 65px;">出生年月<br>（岁）</span>
									<span style="flex:0 0 65px;word-wrap: break-word;">{{birthdate}},{{age}}</span>
								</div>
								<div class="line">
									<span style="flex:0 0 55px;">民族</span>
									<span class="bm" style="flex:0 0 70px;">{{people}}</span>
									<span class="br" style="flex:0 0 60px;">籍贯</span>
									<span class="br" style="flex:0 0 80px;">{{native_place}}</span>
									<span class="br" style="flex:0 0 65px;">出生地</span>
									<span style="flex:0 0 65px;">{{birthplace}}</span>
								</div>
								<div class="line">
									<span style="flex:0 0 55px;">入党<br>时间</span>
									<span class="bm" style="flex:0 0 70px;">{{party_time}}</span>
									<span class="br" style="flex:0 0 60px;">参加工<br>作时间</span>
									<span class="br" style="flex:0 0 80px;">{{attack_time}}</span>
									<span class="br" style="flex:0 0 65px;">健康状况</span>
									<span style="flex:0 0 65px;">{{health_condition}}</span>
								</div>
								<div class="line" style="border: none;">
									<span style="flex:0 0 55px;">专业技<br>术职务</span>
									<span class="bm" style="flex:0 0 131px;">{{professional_title}}</span>
									<span class="br" style="flex:0 0 80px;">熟悉专业<br>有何专长</span>
									<span style="flex:0 0 131px;">{{speciality}}</span>
								</div>
							</div>
						</div>

						<!--第二行-->
						<div class="b  bup flex" style="overflow: hidden;">
							<div class="fl clearfix line" style="width: 55px;border: none;">
								<span style="flex:0 0 55px;">学历<br>学位</span>
							</div>
							<div class="fr clearfix" style="width: 445px;">
								<div class="line">
									<span class="bm" style="flex: 0 0 70px;">全日制<br>教育</span>
									<span class="br" style="flex: 0 0 141px;">{{full_time_education}}</span>
									<span class="br" style="flex:0 0 65px;">毕业院校<br>系及专业</span>
									<span class="br" style="flex: 0 0 170px;">{{colleges_and_majors1}}</span>
								</div>
								<div class="line" style="border: none;">
									<span class="bm" style="flex: 0 0 70px;">在职<br>教育</span>
									<span class="br" style="flex: 0 0 141px;">{{part_time_education}}</span>
									<span class="br" style="flex:0 0 65px;">毕业院校<br>系及专业</span>
									<span class="br" style="flex: 0 0 170px;">{{colleges_and_majors2}}</span>
								</div>
							</div>
						</div>

						<!--第三行-->
						<div class="line">
							<span class="br" style="flex:0 0 126px">现任职务</span>
							<span style="flex: 0 0 374px;">{{present_title}}</span>
						</div>
						<!--第四行-->
						<div class="line">
							<span class="br" style="flex:0 0 126px">拟任职务</span>
							<span style="flex: 0 0 374px;">{{designated_title}}</span>
						</div>
						<!--第五行-->
						<div class="line">
							<span class="br" style="flex:0 0 126px">拟免职务</span>
							<span style="flex: 0 0 374px;">{{remove_title}}</span>
						</div>

						<!--第六行-->
						<div class="line resume" style="border: none;">
							<span class="br" style="flex:0 0 45px">简 <br><br>历<br></span>
							<span style="flex: 0 0 454px;text-align: left;padding-left: 20px;box-sizing: border-box; white-space:pre-wrap;align-items: flex-start;justify-content: flex-start;">{{curriculum_vitae}}</span>
						</div>
					</div>
					<div style="page-break-after:always"></div>
					<div class="form-wrapper-down">
						<!--第七行-->
						<div class="line prize">
							<span class="br" style="flex:0 0 45px">奖<br>惩<br>情<br>况</span>
							<span style="flex: 0 0 454px;text-align: left;text-indent: 20px;white-space:pre-wrap;">{{rewards_and_penalties}}</span>
						</div>

						<!--第八行-->
						<div class="line">
							<span class="br" style="flex:0 0 45px">年度<br>考核<br>结果</span>
							<span style="flex: 0 0 454px;text-align: left;text-indent: 20px;white-space:pre-wrap;">{{evaluation_result}}</span>
						</div>

						<!--第八行-->
						<div class="line">
							<span class="br" style="flex:0 0 45px">任<br>免<br>理<br>由</span>
							<span style="flex: 0 0 454px;text-align: left;text-indent: 20px;white-space:pre-wrap;">{{reason}}</span>
						</div>

						<!--第九行-->
						<div class="line">
							<span class="br" style="flex:0 0 45px;padding: 0;">家<br>庭<br>主<br>要<br>成<br>员<br>及<br>重<br>要<br>社<br>会<br>关<br>系</span>
							<div style="flex: 0 0 454px;">
								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">称谓</span>
									<span class="br" style="flex:0 0 50px">姓名</span>
									<span class="br" style="flex:0 0 35px">年<br>龄</span>
									<span class="br" style="flex:0 0 50px">政治<br>面貌</span>
									<span style="flex:0 0 265px">工作单位及职务</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation1}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name1}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age1}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status1}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name1}}</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation2}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name2}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age2}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status2}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name2}}</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation3}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name3}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age3}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status3}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name3}}</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation4}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name4}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age4}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status4}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name4}}</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation5}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name5}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age5}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status5}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name5}}</span>
								</div>

								<div class="line" style="width: 100%;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation6}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name6}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age6}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status6}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name6}}</span>
								</div>

								<div class="line" style="width: 100%;border: none;">
									<span class="br" style="flex:0 0 50px">{{kinsfolk_relation7}}</span>
									<span class="br" style="flex:0 0 50px">{{kinsfolk_name7}}</span>
									<span class="br" style="flex:0 0 35px">{{kinsfolk_age7}}</span>
									<span class="br" style="flex:0 0 50px">{{politics_status7}}</span>
									<span style="flex:0 0 265px">&nbsp;{{company_name7}}</span>
								</div>
							</div>
						</div>

						<!--第十行-->
						<div class="line">
							<span class="br" style="flex:0 0 45px">呈<br>报<br>单<br>位</span>
							<span style="flex: 0 0 454px;text-align: left;text-indent: 20px;white-space:pre-wrap;">{{reporting_unit}}</span>
						</div>

						<!--第十一行-->
						<div class="line" style="border: none;">
							<span class="br" style="flex:0 0 45px">审批<br>机关<br>意见<br></span>
							<span class="br" style="flex: 0 0 170px;">
								<div>
									<p>（盖章）</p>
									<p> &nbsp;年 &nbsp;月  &nbsp;日</p>
								</div>
							</span>
							<span class="br" style="flex:0 0 45px">执政<br>机关<br>任免<br>意见</span>
							<span style="flex:0 0 238px">
								<div>
									<p>（盖章）</p>
									<p> &nbsp;年 &nbsp;月  &nbsp;日</p>
		
								</div>
							</span>
						</div>
						<div style="width: 400px;height: 20px;margin: 0 auto -20px;line-height: 20px;">
							<span class="fl clearfix">填表人:</span>
							<p class="fl clearfix" style="width:65px;height: 20px;">{{preparer}}</p>
						</div>
					</div>

				</div>

			</div>
		</section>
		<div style="padding: 30px 0;">
			<router-link class="editor" to="/appoint">编辑</router-link>
			<button class="down_load" @click="print">下载文件</button>
			<router-link class="back" to="/index">返回主页</router-link>
		</div>
	</div>

	</div>
</template>

<script>
	import html2Canvas from 'html2canvas'
	import JsPDF from 'jspdf'
	import Qs from 'qs'
	export default {
		data() {
			return {
				age: '',
				name: '',
				sex: '',
				birthdate: '',
				old: '',
				people: '',
				native_place: '',
				birthplace: '',
				party_time: '',
				attack_time: '',
				health_condition: '',
				professional_title: '',
				speciality: '',
				full_time_education: '',
				colleges_and_majors1: '',
				part_time_education: '',
				colleges_and_majors2: '',
				present_title: '',
				designated_title: '',
				remove_title: '',
				curriculum_vitae: '',
				rewards_and_penalties: '',
				evaluation_result: '',
				reason: '',
				kinsfolk_relation1: '',
				kinsfolk_relation2: '',
				kinsfolk_relation3: '',
				kinsfolk_relation4: '',
				kinsfolk_relation5: '',
				kinsfolk_relation6: '',
				kinsfolk_relation7: '',
				kinsfolk_name1: '',
				kinsfolk_name2: '',
				kinsfolk_name3: '',
				kinsfolk_name4: '',
				kinsfolk_name5: '',
				kinsfolk_name6: '',
				kinsfolk_name7: '',
				kinsfolk_age1: '',
				kinsfolk_age2: '',
				kinsfolk_age3: '',
				kinsfolk_age4: '',
				kinsfolk_age5: '',
				kinsfolk_age6: '',
				kinsfolk_age7: '',
				politics_status1: '',
				politics_status2: '',
				politics_status3: '',
				politics_status4: '',
				politics_status5: '',
				politics_status6: '',
				politics_status7: '',
				company_name1: '',
				company_name2: '',
				company_name3: '',
				company_name4: '',
				company_name5: '',
				company_name6: '',
				company_name7: '',
				reporting_unit: '',
				preparer: '',
			}
		},
		created() {},
		mounted() {
			if(sessionStorage.getItem('Token')) {
				var token = sessionStorage.getItem('Token');
			};
			if(sessionStorage.getItem('renMian_id')) {
				var renMian_id = sessionStorage.getItem('renMian_id');
			};
			var data = {
				'id': renMian_id,
				'access-token': token
			};
			this.$axios({
				method: 'post',
				url: 'director/appointremovalinfo',
				data: Qs.stringify(data)
			}).then(response => {
				if(response.data.state == 2) {
					console.log(response.data);
					this.age = response.data.data.age;
					this.name = response.data.data.name;
					this.sex = response.data.data.sex;
					this.birthdate = response.data.data.birthdate;
					this.people = response.data.data.people;
					this.native_place = response.data.data.native_place;
					this.birthplace = response.data.data.birthplace;
					this.party_time = response.data.data.party_time;
					this.attack_time = response.data.data.attack_time;
					this.health_condition = response.data.data.health_condition;
					this.professional_title = response.data.data.professional_title;
					this.speciality = response.data.data.speciality;
					this.full_time_education = response.data.data.full_time_education;
					this.colleges_and_majors1 = response.data.data.colleges_and_majors1;
					this.part_time_education = response.data.data.part_time_education;
					this.colleges_and_majors2 = response.data.data.colleges_and_majors2;
					this.present_title = response.data.data.present_title;
					this.designated_title = response.data.data.designated_title;
					this.remove_title = response.data.data.remove_title;
					this.curriculum_vitae = response.data.data.curriculum_vitae;
					this.rewards_and_penalties = response.data.data.rewards_and_penalties;
					this.evaluation_result = response.data.data.evaluation_result;
					this.reason = response.data.data.reason;
					this.kinsfolk_relation1 = response.data.data.kinsfolk_relation1;
					this.kinsfolk_relation2 = response.data.data.kinsfolk_relation2;
					this.kinsfolk_relation3 = response.data.data.kinsfolk_relation3;
					this.kinsfolk_relation4 = response.data.data.kinsfolk_relation4;
					this.kinsfolk_relation5 = response.data.data.kinsfolk_relation5;
					this.kinsfolk_relation6 = response.data.data.kinsfolk_relation6;
					this.kinsfolk_relation7 = response.data.data.kinsfolk_relation7;
					this.kinsfolk_name1 = response.data.data.kinsfolk_name1;
					this.kinsfolk_name2 = response.data.data.kinsfolk_name2;
					this.kinsfolk_name3 = response.data.data.kinsfolk_name3;
					this.kinsfolk_name4 = response.data.data.kinsfolk_name4;
					this.kinsfolk_name5 = response.data.data.kinsfolk_name5;
					this.kinsfolk_name6 = response.data.data.kinsfolk_name6;
					this.kinsfolk_name7 = response.data.data.kinsfolk_name7;
					this.kinsfolk_age1 = response.data.data.kinsfolk_age1;
					this.kinsfolk_age2 = response.data.data.kinsfolk_age2;
					this.kinsfolk_age3 = response.data.data.kinsfolk_age3;
					this.kinsfolk_age4 = response.data.data.kinsfolk_age4;
					this.kinsfolk_age5 = response.data.data.kinsfolk_age5;
					this.kinsfolk_age6 = response.data.data.kinsfolk_age6;
					this.kinsfolk_age7 = response.data.data.kinsfolk_age7;
					this.politics_status1 = response.data.data.politics_status1;
					this.politics_status2 = response.data.data.politics_status2;
					this.politics_status3 = response.data.data.politics_status3;
					this.politics_status4 = response.data.data.politics_status4;
					this.politics_status5 = response.data.data.politics_status5;
					this.politics_status6 = response.data.data.politics_status6;
					this.politics_status7 = response.data.data.politics_status7;
					this.company_name1 = response.data.data.company_name1;
					this.company_name2 = response.data.data.company_name2;
					this.company_name3 = response.data.data.company_name3;
					this.company_name4 = response.data.data.company_name4;
					this.company_name5 = response.data.data.company_name5;
					this.company_name6 = response.data.data.company_name6;
					this.company_name7 = response.data.data.company_name7;
					this.reporting_unit = response.data.data.reporting_unit;
					this.preparer = response.data.data.preparer;
				}

			});
		},
		methods: {
			print() {
				this.$print(this.$refs.print);
			},
		}
	}
</script>
<style scoped>
	/*表格*/
	
	.clearfix::after {
		content: ".";
		clear: both;
		visibility: hidden;
		height: 0;
		display: block;
		line-height: 0;
	}
	
	.clearfix {
		zoom: 1;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.bm {
		border-style: hidden solid hidden solid;
	}
	
	.bup {
		border-style: solid hidden solid hidden;
	}
	
	.bl {
		border-style: hidden hidden hidden solid;
	}
	
	.bt {
		border-style: solid hidden hidden hidden;
	}
	
	.br {
		border-style: hidden solid hidden hidden;
	}
	
	.bb {
		border-style: hidden hidden solid hidden;
	}
	
	.b {
		border-width: 1px;
		border-color: #333;
		box-sizing: border-box;
	}
	
	.bsize {
		box-sizing: border-box;
	}
	
	.con {
		width: 100%;
		text-align: center;
		padding-top: 20px;
	}
	
	@media print {
		@page {
	      	size: auto;  /* auto is the initial value */
	      	margin: 0mm; /* this affects the margin in the printer settings */
	    }

		.form{
			transform-origin: 50% 0;
			transform: scale(1.2);
			-webkit-transform: scale(1.2);
			-moz-transform: scale(1.2);
			-ms-transform: scale(1.2);
			-o-transform: scale(1.2);
			font-stretch: normal;
			margin: 0 auto;
			font-family: '宋体';
			padding-bottom: 0;
		}
		.resume {
			height: 380px;
		}
	}
	
	.form {
		font-stretch: normal;
		font-family: '宋体';
		background: #fff;
		width: 580px;
		color: #333;
		margin: 0 auto;
		padding-bottom: 15px;
	}
	
	.form .title {
		text-align: center;
		font-size: 20px;
		color: #000;
		font-weight: bold;
		padding: 20px 0 10px;
	}
	
	.form-wrapper {
		color: #333;
		font-size: 8px;
		width: 500px;
		margin: 0 auto;
		/*border: 1px solid #333;*/
	}
	
	.form-wrapper-up {
		border: 1px solid #333;
	}
	
	.form-wrapper-down {
		border-top: none;
		border: 1px solid #333;
	}
	
	.line {
		display: flex;
		align-items: stretch;
		border-style: hidden hidden solid hidden;
		border-width: 1px;
		border-color: #333;
		box-sizing: border-box;
	}
	
	.line span {
		font-size: 8px;
		border-width: 1px;
		border-color: #333;
		padding: 3px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.down_load {
		border: none;
		display: inline-block;
		margin: 0 auto;
		text-align: center;
		color: #fff;
		font-size: 16px;
		line-height: 40px;
		width: 166px;
		height: 40px;
		border-radius: 4px;
		background: rgba(24, 144, 255, 1);
		/*background: rgba(24, 144, 255, 1) url(../../static/img/up.png) no-repeat 13px 13px;
		background-size: 14px 14px;*/
	}
	.editor{
		display: inline-block;
		color: #fff;
		font-size: 16px;
		line-height: 40px;
		width: 166px;
		height: 40px;
		border-radius: 4px;
		background: rgba(24, 144, 255, 1);
		margin-right: 20px;
	}
	.back {
		display: inline-block;
		color: #fff;
		font-size: 16px;
		line-height: 40px;
		width: 166px;
		height: 40px;
		border-radius: 4px;
		background: rgba(24, 144, 255, 1);
		margin-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Table1.vue